const videoRouter = [
  {
    path: '/video/controller/battery',
    component: () => import('@/views/video/controller/battery'),
    name: 'ControllerBattery',
    meta: { title: '指导视频' }
  }
]
export default videoRouter



// WEBPACK FOOTER //
// ./src/router/modules/video.js